module.exports = __webpack_public_path__ + "img/Bullhorn-Multicolor.075f7c79.svg";